import { Component, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { Constant } from 'src/app/shared/service/utils/contant';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import { EditProjetComponent } from '../../plananalytique/programme/edit-projet/edit-projet.component';

@Component({
  selector: 'app-revue-budgetaire',
  templateUrl: './revue-budgetaire.component.html',
  styleUrl: './revue-budgetaire.component.scss'
})

export class RevueBudgetaireComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;
  filteredData: any[] = []; // Données filtrées
  searchTerm: string = ''; // Terme de recherche
  revuBudgetaire: any = [];
  modalRef: NgbModalRef | null = null;
  paginatedItems: any[] = [];
  paginatedTacheItems: any[] = [];
  firstTache: number = 0;
  rowsTache: number = 10;
  totalRecordsTache: number = 0; // Nombre total d'éléments
  isLoading: boolean = false;

  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  itemToDelete!: any;
  selectedProgramme!: any;
  @ViewChild('tacheModal') modalContent!: TemplateRef<any>;
  @ViewChild('editTacheModal') modalContent2!: TemplateRef<any>;
  programmeItems: any = [];
  directionItems: any = [];
  actionItems: any = [];
  selectedDirection: any;
  selectedAction: any;
  constructor(
    private modalService: NgbModal,

    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {

    // this.projetService.projetCreated$.subscribe(() => {
    //   this.fetchDataAction();
    // });
  }

  ngOnInit(): void {

    this.fetchRevueBudgetaire();
    this.fetchProgramme();

  }

  fetchRevueBudgetaire() {
    this.isLoading = true;

    let requestData = {
      programme_ref: this.selectedProgramme,
      action_ref: this.selectedAction,
      direction_ref: this.selectedDirection,
      annee: this.localstorage.getExerciceToUserToSuivieEvaluation()
    }

    this.ngxService.start();

    this.paramservice.fetchRevueBudgetaire(requestData).subscribe(
      (response: any) => {
        this.isLoading = false;
        this.revuBudgetaire = response.data;
        this.filteredData = [...this.revuBudgetaire]; // Initialiser filteredData avec toutes les données
        this.totalRecords = this.filteredData.length;
        this.ngxService.stop();

        this.updatePagination();
      //  this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });

        ////console.log("this.actionData", this.revuBudgetaire);
      },
      (error:any) => {
        ////console.log("une erreur est survenu", error);
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error.error.message });

      }
    );
  }


  fetchProgramme() {
    this.paramservice.fetchDataPrograme().subscribe(
      (response: any) => {
        this.programmeItems = response.data;
        this.getAction();
      },
      (error) => {
        ////console.log("une erreur est survenu", error);
      }
    );
  }
  getAction() {
    this.paramservice.fetchDataAction().subscribe(
      (response: any) => {

        this.actionItems = response.data;
        this.getDirection();
      },
      (error) => {
      }
    )
  }
  getDirection() {
    this.paramservice.fetchDataDirection().subscribe(
      (response: any) => {

        this.directionItems = response.data;
      },
      (error) => {
      }
    )
  }




  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePagination();
  }

  updatePagination() {
    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.filteredData.slice(start, end);

    ////console.log("this.updateRessourceStats",this.paginatedItems);
  }
  applyFilter(term: string) {
    this.searchTerm = term.trim().toLowerCase();

    if (this.searchTerm) {
      this.filteredData = this.revuBudgetaire.filter(item =>
        item.sigle.toLowerCase().includes(this.searchTerm)
      );
    } else {
      // Réinitialiser les données filtrées si la recherche est vide
      this.filteredData = [...this.revuBudgetaire];
    }

    this.totalRecords = this.filteredData.length;
    this.first = 0; // Revenir à la première page après le filtrage
    this.updatePagination();
  }

  confirmDeletion(project: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer ce projet ' + project.libelle + '?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deleteProjet(project.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            ////console.log("la reponse du webserice", response);
            this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: response.message });
            this.fetchRevueBudgetaire();
          },
          (error) => {
            this.ngxService.stop();
            ////console.log("une erreur est survenu", error);
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });
          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }


  confirmDeletionTache(project: any) {
    this.confirmationService.confirm({
      message: 'Êtes-vous sûr de vouloir supprimer cette tache ',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.ngxService.start();
        this.paramservice.deleteTache(project.reference).subscribe(
          (response: any) => {
            this.ngxService.stop();
            ////console.log("la reponse du webserice", response);
            this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: response.message });
            this.fetchRevueBudgetaire();
            this.modalService.dismissAll();
          },
          (error) => {
            this.ngxService.stop();
            ////console.log("une erreur est survenu", error);
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: "Une erreur est survenue. Veuillez réessayé" });
          },
        )
      },
      reject: () => {
        //this.messageService.add({ severity: 'warn', summary: '', detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }

  tacheItems: any = [];

  openTacheModal(item: any) {

    console.log("item", item);

    this.tacheItems = item.taches;

    this.updatePaginationTache();

    this.modalRef = this.modalService.open(this.modalContent, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    });
  }

  onPageChangeTache(event: any) {
    this.firstTache = event.first;
    this.rowsTache = event.rows;
    this.updatePaginationTache();
  }

  updatePaginationTache() {
    const start = this.firstTache;
    const end = this.firstTache + this.rowsTache;
    this.paginatedTacheItems = this.tacheItems.slice(start, end);

    ////console.log("this.updateRessourceStats",this.paginatedItems);
  }
  EditModal(projetIndicateur: any) {
    this.localstorage.saveProjet(projetIndicateur)
    const modalRef = this.modalService.open(EditProjetComponent, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    },);
  }

  editItem:any={};

   EditModalTache(item: any) {
    
    console.log("item", item);
    
    this.editItem = item;

    this.modalRef = this.modalService.open(this.modalContent2, {
      backdrop: 'static',
      centered: true,
      size: 'xl'
    });
  }


  saveEdit() {
  this.paramservice.updateTache(this.editItem.reference,this.editItem).subscribe({
    next: (response: any) => {

      // mettre à jour la liste localement
      const index = this.tacheItems.findIndex(
        (t: any) => t.code === this.editItem.code
      );

      if (index !== -1) {
        this.tacheItems[index] = { ...this.editItem };
      }
      
      this.updatePaginationTache();

    //    this.modalService.dismissAll();

      // message succès (si tu utilises un service)
      this.messageService.add({
        severity: 'success',
        summary: 'Succès',
        detail: 'Tâche modifiée avec succès'
      });
    },

    error: (err: any) => {
      console.error(err);
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors de la modification'
      });
    }
  });
}

  addProjetToActiviter(item: any) {

    ////console.log("item");

    this.localstorage.saveProjetActivite(item);

    this.router.navigate(['/suivi/planification/projet-activite'])
  }
}
